// invoiceview.js
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  Card,
  Row,
  Col,
  Typography,
  Tag,
  Space,
  Button,
  Dropdown,
  Table,
  Input,
  Checkbox,
} from "antd";
import {
  MoreOutlined,
  ArrowLeftOutlined,
  PlusOutlined,
  DownOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

export default function InvoiceView() {
  const { id } = useParams();

  // Hardcoded data
  const info = {
    title: "Summer Music Festival",
    meta: [
      { icon: "📅", value: "June 15, 2025" },
      { icon: "🏷️", value: "Event" },
    ],
    stats: [
      { label: "EVENT VALUE", value: "$18,500" },
      { label: "TOTAL INVOICED", value: "$55,500" },
      { label: "INVOICES", value: "3" },
      { label: "AMOUNT PAID", value: "$37,000" },
    ],
  };

  const schedule = {
    active: true,
    amount: 18500,
    frequency: "Monthly",
    meta: [
      { label: "NEXT INVOICE", value: "Jan 15, 2026" },
      { label: "STARTED", value: "Sep 15, 2025" },
      { label: "GENERATED", value: "3 invoices" },
      { label: "FREQUENCY", value: "Unlimited" },
    ],
  };

  const invoices = [
    {
      id: 1,
      number: "INV-001",
      date: "Sep 15, 2025",
      amount: 18500,
      status: "paid",
    },
    {
      id: 2,
      number: "INV-002",
      date: "Oct 15, 2025",
      amount: 18500,
      status: "paid",
    },
    {
      id: 3,
      number: "INV-003",
      date: "Nov 15, 2025",
      amount: 18500,
      status: "sent",
    },
  ];

  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);

  const filtered = invoices.filter((inv) =>
    inv.number.toLowerCase().includes(search.toLowerCase())
  );

  const toggleSelectAll = (checked) => {
    setSelected(checked ? filtered.map((x) => x.id) : []);
  };

  const toggleRow = (id, checked) => {
    if (checked) setSelected([...selected, id]);
    else setSelected(selected.filter((x) => x !== id));
  };

  const invoiceColumns = [
    {
      title: "Invoice",
      dataIndex: "number",
      render: (val) => <Text strong>{val}</Text>,
    },
    { title: "Date", dataIndex: "date" },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (amt) => <Text strong>${amt.toLocaleString()}</Text>,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (s) => {
        const map = {
          paid: { color: "green", text: "PAID" },
          sent: { color: "blue", text: "SENT" },
        };
        return <Tag color={map[s]?.color}>{map[s]?.text}</Tag>;
      },
    },
    {
      title: "Actions",
      render: (_, row) => (
        <Space>
          <Button size="small">View</Button>
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                { key: "pdf", label: "Download PDF" },
                { key: "email", label: "Send Email" },
                { key: "edit", label: "Edit" },
                { key: "delete", label: <span style={{ color: "red" }}>Delete</span> },
              ],
            }}
          >
            <Button size="small" icon={<MoreOutlined />} />
          </Dropdown>
        </Space>
      ),
    },
    {
      title: (
        <Checkbox
          checked={selected.length === filtered.length && filtered.length > 0}
          onChange={(e) => toggleSelectAll(e.target.checked)}
        />
      ),
      dataIndex: "id",
      render: (_, row) => (
        <Checkbox
          checked={selected.includes(row.id)}
          onChange={(e) => toggleRow(row.id, e.target.checked)}
        />
      ),
      width: 50,
    },
  ];

  return (
    <div>
      <Row gutter={24}>
        {/* LEFT CARD */}
        <Col xs={24} lg={16}>
          <Card>
            <Space direction="vertical" style={{ width: "100%" }}>
              <Space style={{ cursor: "pointer" }}>
                <ArrowLeftOutlined />
                <Text>Back to Events</Text>
              </Space>

              <Title level={2}>{info.title}</Title>

              <Space wrap>
                {info.meta.map((m, idx) => (
                  <Text key={idx}>
                    {m.icon} {m.value}
                  </Text>
                ))}
              </Space>

              <Row gutter={16} style={{ marginTop: 16 }}>
                {info.stats.map((s, idx) => (
                  <Col span={12} key={idx}>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      {s.label}
                    </Text>
                    <br />
                    <Title level={4} style={{ margin: 0 }}>
                      {s.value}
                    </Title>
                  </Col>
                ))}
              </Row>
            </Space>
          </Card>
        </Col>

        {/* RIGHT SCHEDULE CARD */}
        <Col xs={24} lg={8}>
          <Card
            style={{
              background:
                "linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)",
              color: "white",
            }}
          >
            <Space
              style={{ justifyContent: "space-between", width: "100%" }}
              align="start"
            >
              {schedule.active && (
                <Tag color="green" style={{ borderRadius: 20 }}>
                  Active
                </Tag>
              )}

              <Space>
                <Button size="small" type="primary">Edit</Button>
                <Dropdown

                  trigger={["click"]}
                  menu={{
                    items: [
                      { key: "pause", label: "Pause" },
                      {
                        key: "delete",
                        label: <span style={{ color: "red" }}>Delete</span>,
                      },
                    ],
                  }}
                >
                  <Button size="small" type="primary" icon={<MoreOutlined />} />
                </Dropdown>
              </Space>
            </Space>

            <Title level={2} style={{ color: "white", marginTop: 16 }}>
              ${schedule.amount.toLocaleString()}
            </Title>

            <Tag>{schedule.frequency}</Tag>

            <Row style={{ marginTop: 20 }}>
              {schedule.meta.map((m, idx) => (
                <Col span={12} key={idx} style={{ marginBottom: 12 }}>
                  <Text style={{ opacity: 0.8, fontSize: 12,color:'white' }}>{m.label}</Text>
                  <br />
                  <Text strong style={{ color: "white" }}>
                    {m.value}
                  </Text>
                </Col>
              ))}
            </Row>
          </Card>
        </Col>
      </Row>

      {/* GENERATED INVOICES */}
      <Card style={{ marginTop: 24 }}>
        <Row justify="space-between" align="middle">
          <Title level={4}>
            Generated Invoices <Tag>{invoices.length}</Tag>
          </Title>

          <Button type="primary" icon={<PlusOutlined />}>
            Manual Invoice
          </Button>
        </Row>

        <Space style={{ marginTop: 16 }}>
          <Input
            placeholder="Search invoices..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: 260 }}
          />
          <Button>
            Filter <DownOutlined />
          </Button>
          <Button>Export</Button>
        </Space>

        {selected.length > 0 && (
          <div
            style={{
              marginTop: 16,
              background: "#fafafa",
              padding: 12,
              borderRadius: 6,
            }}
          >
            <Space>
              <Checkbox
                checked={selected.length === filtered.length}
                onChange={(e) => toggleSelectAll(e.target.checked)}
              />
              <Text>
                {selected.length} selected / {filtered.length}
              </Text>
              <Button danger>Bulk Delete</Button>
            </Space>
          </div>
        )}

        <Table
          style={{ marginTop: 16 }}
          dataSource={filtered}
          columns={invoiceColumns}
          rowKey="id"
          pagination={false}
        />
      </Card>
    </div>
  );
}
